<template>
  <div class="cookie-banner">
    <span class="title bold">This website uses cookies</span>
    <p>We use cookies to personalise content and analyse our traffic.</p>
    <div class="cookie-banner__actions">
      <app-button
        @click.native="submitSelectionHandler"
        class="cookie-banner__action"
        size="sm"
        color="success"
        >Allow selection</app-button
      >
      <app-button
        @click.native="submitAllHandler"
        class="cookie-banner__action"
        size="sm"
        color="success"
        >Allow all cookies</app-button
      >
    </div>
    <div class="cookie-banner__options">
      <label class="cookie-banner__option" for="neccessary_cookies">
        <input
          disabled
          checked
          type="checkbox"
          name="neccessary_cookies"
          id="neccessary_cookies"
        />
        Neccessary
      </label>

      <label class="cookie-banner__option" for="google_cookies">
        <input
          type="checkbox"
          name="google_cookie"
          id="google_cookies"
          v-model="cookies.statistics"
        />
        Statistics
      </label>

      <app-button
        @click.native="toggleDetailsHandler()"
        class="cookie-banner__button"
        variant="outline"
        size="sm"
        >{{ detailsButtonText }}</app-button
      >
    </div>

    <div v-show="showDetails" class="cookie-banner__details">
      <app-table :headers="details.headers" :items="details.items">
        <template #provider="cookie">
          <a :href="cookie.providerUrl" v-if="cookie.providerUrl">{{
            cookie.provider
          }}</a>
          <span v-else>{{ cookie.provider }}</span>
        </template>
      </app-table>
    </div>
  </div>
</template>

<script>
import AppTable from '@/components/global/Table';

export default {
  name: 'cookie-banner',
  components: { AppTable },
  data() {
    return {
      showDetails: false,
      cookies: {
        statistics: false,
      },
      details: {
        headers: [
          {
            label: 'Name',
            value: 'name',
            align: 'left',
          },
          {
            label: 'Provider',
            value: 'provider',
            align: 'left',
          },
          {
            label: 'Purpose',
            value: 'purpose',
            align: 'left',
          },
          {
            label: 'Category',
            value: 'category',
            align: 'left',
          },
        ],
        items: [
          {
            name: 'jwt',
            provider: 'maddy.app',
            purpose: 'Keeps you logged in',
            category: 'Neccessary',
          },
          {
            name: 'cookie_settings',
            provider: 'maddy.app',
            purpose: 'Keeps track of your cookie settings',
            category: 'Neccessary',
          },
          {
            name: '_ga',
            provider: 'Google Analytics',
            purpose:
              'Registers a unique ID that is used to generate statistical data on how the visitor uses the website.',
            category: 'Statistics',
            providerUrl: 'https://policies.google.com/privacy',
          },
          {
            name: '_gid',
            provider: 'Google Analytics',
            purpose:
              'Registers a unique ID that is used to generate statistical data on how the visitor uses the website.',
            category: 'Statistics',
            providerUrl: 'https://policies.google.com/privacy',
          },
        ],
      },
    };
  },
  methods: {
    toggleDetailsHandler() {
      this.showDetails = !this.showDetails;
    },
    setCookie(name, value) {
      const d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);

      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/`;
    },
    submitSelectionHandler() {
      let string = 'neccessary';
      if (this.cookies.statistics) string += ',statistics';
      this.setCookie('cookie_settings', string);
      this.$emit('accept');
    },
    submitAllHandler() {
      this.setCookie('cookie_settings', 'neccessary,statistics');
      this.$emit('accept');
    },
  },
  computed: {
    detailsButtonText() {
      return this.showDetails ? 'Hide details' : 'Show details';
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-banner {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  padding: 1rem;
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.05);
  z-index: 1200;
  max-width: 640px;
  border-radius: 8px 8px 0 0;

  &__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

  &__action {
    margin-left: 0.5rem;
  }

  &__options {
    display: flex;
    align-items: center;

    .cookie-banner__button {
      margin-left: auto;
    }
  }

  &__option {
    margin-right: 1rem;
  }

  &__details {
    border-top: 1px color('grey') dashed;
    margin-top: 1rem;
    padding-top: 1rem;
  }

  .table {
    font-size: calc-font-size(14);
  }
}
</style>
